import { Route } from 'src/constants/routes';

const titles = {
  [Route.DASHBOARD]: 'Tableau de bord',
  [Route.CONTACTS]: 'Contacts',
  [Route.INVOICES]: 'Factures',
  [Route.PAYMENTS]: 'Paiements',
  [Route.SUBSCRIPTIONS]: 'Abonnements',
  [Route.FUNDRAISING]: 'Levée de fonds',
  [Route.FUNDRAISING_TRANSACTION]: 'Transaction des levée de fonds',
  [Route.SETTINGS]: 'Configurations',
  [Route.INVOICES_PAYMENT]: 'Factures pour Paiement',
  [Route.INVOICES_CONTACT]: 'Factures pour Contact',
  [Route.PAYMENTS_INVOICE]: 'Paiements pour Factures',
  [Route.PAYMENTS_CONTACT]: 'Paiements pour Contact',
  [Route.ORGANISATIONS]: 'Organisations',
};

export default titles;
